import {
  LANGUAGE_TYPES,
  LANDING_PAGE_OPTIONS,
} from './consts';

export const KRTLocations = {
  [LANGUAGE_TYPES.ENGLISH]: [
    {
      id: 4,
      name: _TL_('American Samoa'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 158,
      name: _TL_('Anguilla'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 7,
      name: _TL_('Antigua and Barbuda'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 205,
      name: _TL_('Armenia'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 131,
      name: _TL_('Aruba'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 203,
      name: _TL_('Azerbaijan'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 11,
      name: _TL_('Bahamas'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 204,
      name: _TL_('Bahrain'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 12,
      name: _TL_('Bangladesh'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 13,
      name: _TL_('Barbados'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 21,
      name: _TL_('Belize'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 15,
      name: _TL_('Bermuda'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 18,
      name: _TL_('Botswana'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 24,
      name: _TL_('British Virgin Islands'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 25,
      name: _TL_('Brunei'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 34,
      name: _TL_('Cayman Islands'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 35,
      name: _TL_('Central African Republic'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 41,
      name: _TL_('Christmas Island'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 42,
      name: _TL_('Cocos (Keeling) Islands'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 47,
      name: _TL_('Cook Islands'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 69,
      name: _TL_('Djibouti'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 54,
      name: _TL_('Dominica'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 187,
      name: _TL_('Egypt'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 59,
      name: _TL_('Ethiopia'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 60,
      name: _TL_('Eritrea'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 62,
      name: _TL_('Faroe Islands'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 199,
      name: _TL_('Fiji'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 208,
      name: _TL_('Georgia'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 74,
      name: _TL_('Gibraltar'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 76,
      name: _TL_('Greece'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 77,
      name: _TL_('Greenland'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 78,
      name: _TL_('Grenada'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 80,
      name: _TL_('Guam'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 153,
      name: _TL_('Guinea-Bissau'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 83,
      name: _TL_('Guyana'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 90,
      name: _TL_('India'),
      landingPage: LANDING_PAGE_OPTIONS.All,
    },
    {
      id: 91,
      name: _TL_('Indonesia'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 228,
      name: _TL_('Iraq'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 92,
      name: _TL_('Ireland'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 93,
      name: _TL_('Italy'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 95,
      name: _TL_('Jamaica'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 101,
      name: _TL_('Kyrgyzstan'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 103,
      name: _TL_('Lesotho'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 106,
      name: _TL_('Libya'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 111,
      name: _TL_('Malawi'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 112,
      name: _TL_('Malaysia'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 113,
      name: _TL_('Maldives'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 142,
      name: _TL_('Marshall Islands'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 118,
      name: _TL_('Mauritius'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 121,
      name: _TL_('Mongolia'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 122,
      name: _TL_('Moldova'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 123,
      name: _TL_('Montserrat'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 126,
      name: _TL_('Namibia'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 127,
      name: _TL_('Nauru'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 128,
      name: _TL_('Nepal'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 129,
      name: _TL_('Netherlands'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 134,
      name: _TL_('New Zealand'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 137,
      name: _TL_('Nigeria'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 223,
      name: _TL_('Niue'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 138,
      name: _TL_('Norfolk Island'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 140,
      name: _TL_('Northern Mariana Islands'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 214,
      name: _TL_('Oman'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 144,
      name: _TL_('Pakistan'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 143,
      name: _TL_('Palau'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 146,
      name: _TL_('Papua New Guinea'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 149,
      name: _TL_('Philippines'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 150,
      name: _TL_('Pitcairn Islands'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 215,
      name: _TL_('Qatar'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 157,
      name: _TL_('Rwanda'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 230,
      name: _TL_('Saint Kitts and Nevis'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 231,
      name: _TL_('Saint Lucia'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 233,
      name: _TL_('Saint Vincent and the Grenadines'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 195,
      name: _TL_('Samoa'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 162,
      name: _TL_('Seychelles'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 163,
      name: _TL_('Sierra Leone'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 164,
      name: _TL_('Singapore'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 225,
      name: _TL_('Somalia'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 168,
      name: _TL_('South Africa'),
      landingPage: LANDING_PAGE_OPTIONS.All,
    },
    {
      id: 170,
      name: _TL_('Spain'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 36,
      name: _TL_('Sri Lanka'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 172,
      name: _TL_('Suriname'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 174,
      name: _TL_('Sweden'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 175,
      name: _TL_('Switzerland'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 176,
      name: _TL_('Tajikistan'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 189,
      name: _TL_('Tanzania'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 177,
      name: _TL_('Thailand'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 71,
      name: _TL_('The Gambia'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 179,
      name: _TL_('Tokelau'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 180,
      name: _TL_('Tonga'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 181,
      name: _TL_('Trinidad and Tobago'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 184,
      name: _TL_('Turks and Caicos Islands'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 234,
      name: _TL_('Tuvalu'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 185,
      name: _TL_('Uganda'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 218,
      name: _TL_('United Arab Emirates'),
      landingPage: LANDING_PAGE_OPTIONS.All,
    },
    {
      id: 237,
      name: _TL_('United States Virgin Islands'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 133,
      name: _TL_('Vanuatu'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 166,
      name: _TL_('Vietnam'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 196,
      name: _TL_('Zambia'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    },
    {
      id: 169,
      name: _TL_('Zimbabwe'),
      landingPage: LANDING_PAGE_OPTIONS.U2K,
    }],
  [LANGUAGE_TYPES.FRENCH]: [{
    id: 3,
    name: _TL_('Algeria'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 5,
    name: _TL_('Andorra'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 14,
    name: _TL_('Belgium'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 52,
    name: _TL_('Benin'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 191,
    name: _TL_('Burkina Faso'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 31,
    name: _TL_('Cameroon'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 35,
    name: _TL_('Central African Republic'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 226,
    name: _TL_('Comoros'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 94,
    name: _TL_('Cote d\'Ivoire'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 46,
    name: _TL_('Democratic Republic of the Congo'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 69,
    name: _TL_('Djibouti'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 1279,
    name: _TL_('French Guiana'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 1292,
    name: _TL_('French Polynesia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 70,
    name: _TL_('Gabon'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 79,
    name: _TL_('Guadeloupe'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 82,
    name: _TL_('Guinea'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 84,
    name: _TL_('Haiti'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 109,
    name: _TL_('Luxembourg'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 110,
    name: _TL_('Madagascar'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 116,
    name: _TL_('Martinique'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 117,
    name: _TL_('Mauritania'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 1303,
    name: _TL_('Mayotte'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 120,
    name: _TL_('Monaco'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 1289,
    name: _TL_('New Caledonia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 136,
    name: _TL_('Niger'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 45,
    name: _TL_('Republic of Congo'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 155,
    name: _TL_('Reunion'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 1293,
    name: _TL_('Saint Pierre and Miquelon'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 161,
    name: _TL_('Senegal'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 175,
    name: _TL_('Switzerland'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 178,
    name: _TL_('Togo'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 227,
    name: _TL_('Tunisia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 1302,
    name: _TL_('Wallis and Futuna'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.GERMAN]: [{
    id: 10,
    name: _TL_('Austria'),
    landingPage: LANDING_PAGE_OPTIONS.All,
  },
  {
    id: 107,
    name: _TL_('Liechtenstein'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 109,
    name: _TL_('Luxembourg'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 175,
    name: _TL_('Switzerland'),
    landingPage: LANDING_PAGE_OPTIONS.All,
  }],
  [LANGUAGE_TYPES.SPANISH]: [{
    id: 170,
    name: _TL_('Spain'),
    landingPage: LANDING_PAGE_OPTIONS.All,
  },
  {
    id: 8,
    name: _TL_('Argentina'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 17,
    name: _TL_('Bolivia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 38,
    name: _TL_('Chile'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 43,
    name: _TL_('Colombia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 48,
    name: _TL_('Costa Rica'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 55,
    name: _TL_('Dominican Republic'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 56,
    name: _TL_('Ecuador'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 57,
    name: _TL_('El Salvador'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 81,
    name: _TL_('Guatemala'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 87,
    name: _TL_('Honduras'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 119,
    name: _TL_('Mexico'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 145,
    name: _TL_('Panama'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 147,
    name: _TL_('Paraguay'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 148,
    name: _TL_('Peru'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 154,
    name: _TL_('Puerto Rico'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 190,
    name: _TL_('United States'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 192,
    name: _TL_('Uruguay'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 202,
    name: _TL_('Venezuela'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.TRADITIONAL_CHINESE]: [{
    id: 40,
    name: _TL_('Taiwan'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 200,
    name: _TL_('Hong Kong SAR'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 201,
    name: _TL_('Macao SAR'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.DUTCH]: [{
    id: 129,
    name: _TL_('Netherlands'),
    landingPage: LANDING_PAGE_OPTIONS.All,
  },
  {
    id: 14,
    name: _TL_('Belgium'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.DANISH]: [{
    id: 53,
    name: _TL_('Denmark'),
    landingPage: LANDING_PAGE_OPTIONS.All,
  }],
  [LANGUAGE_TYPES.SWEDISH]: [{
    id: 174,
    name: _TL_('Sweden'),
    landingPage: LANDING_PAGE_OPTIONS.All,
  }],
  [LANGUAGE_TYPES.NORWEGIAN]: [{
    id: 139,
    name: _TL_('Norway'),
    landingPage: LANDING_PAGE_OPTIONS.All,
  }],
  [LANGUAGE_TYPES.FINNISH]: [{
    id: 65,
    name: _TL_('Finland'),
    landingPage: LANDING_PAGE_OPTIONS.All,
  }],
  [LANGUAGE_TYPES.ITALIAN]: [{
    id: 93,
    name: _TL_('Italy'),
    landingPage: LANDING_PAGE_OPTIONS.All,
  },
  {
    id: 159,
    name: _TL_('San Marino'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 86,
    name: _TL_('Vatican City'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.PORTUGUESE]: [{
    id: 152,
    name: _TL_('Portugal'),
    landingPage: LANDING_PAGE_OPTIONS.All,
  },
  {
    id: 20,
    name: _TL_('Brazil'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 153,
    name: _TL_('Guinea-Bissau'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.CZECH]: [{
    id: 51,
    name: _TL_('Czech Republic'),
    landingPage: LANDING_PAGE_OPTIONS.All,
  }],
  [LANGUAGE_TYPES.POLISH]: [{
    id: 151,
    name: _TL_('Poland'),
    landingPage: LANDING_PAGE_OPTIONS.All,
  }],
  [LANGUAGE_TYPES.ROMANIAN]: [{
    id: 224,
    name: _TL_('Romania'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.HUNGARIAN]: [{
    id: 88,
    name: _TL_('Hungary'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.GREEK]: [{
    id: 76,
    name: _TL_('Greece'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 206,
    name: _TL_('Cyprus'),
    landingPage: LANDING_PAGE_OPTIONS.K2K,
  }],
  [LANGUAGE_TYPES.SLOVAK]: [{
    id: 165,
    name: _TL_('Slovakia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.MALTESE]: [{
    id: 115,
    name: _TL_('Malta'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.BULGARIAN]: [{
    id: 26,
    name: _TL_('Bulgaria'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.CROATIAN]: [{
    id: 49,
    name: _TL_('Croatia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.LITHUANIAN]: [{
    id: 108,
    name: _TL_('Lithuania'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.SLOVENIAN]: [{
    id: 167,
    name: _TL_('Slovenia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.ESTONIAN]: [{
    id: 61,
    name: _TL_('Estonia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.LATVIAN]: [{
    id: 104,
    name: _TL_('Latvia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.ALBANIAN]: [{
    id: 1,
    name: _TL_('Albania'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.BOSNIAN]: [{
    id: 198,
    name: _TL_('Bosnia and Herzegovina'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.ICELANDIC]: [{
    id: 89,
    name: _TL_('Iceland'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.MACEDONIAN]: [{
    id: 186,
    name: _TL_('Republic of North Macedonia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.RUSSIAN]: [{
    id: 101,
    name: _TL_('Kyrgyzstan'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.SERBIAN]: [{
    id: 4993,
    name: _TL_('Serbia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 4994,
    name: _TL_('Montenegro'),
    landingPage: LANDING_PAGE_OPTIONS.K2K,
  }],
  [LANGUAGE_TYPES.TURKISH]: [{
    id: 182,
    name: _TL_('Turkey'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.JAPANESE]: [{
    id: 96,
    name: _TL_('Japan'),
    landingPage: LANDING_PAGE_OPTIONS.All,
  }],
  [LANGUAGE_TYPES.ARABIC]: [{
    id: 216,
    name: _TL_('Saudi Arabia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  {
    id: 69,
    name: _TL_('Djibouti'),
    landingPage: LANDING_PAGE_OPTIONS.K2K,
  },
  {
    id: 226,
    name: _TL_('Comoros'),
    landingPage: LANDING_PAGE_OPTIONS.K2K,
  }, {
    id: 219,
    name: _TL_('Yemen'),
    landingPage: LANDING_PAGE_OPTIONS.K2K,
  }],
  [LANGUAGE_TYPES.HEBREW]: [{
    id: 210,
    name: _TL_('Israel'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.TAGALOG]: [{
    id: 149,
    name: _TL_('Philippines'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.HINDI]: [{
    id: 90,
    name: _TL_('India'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.MALAY]: [{
    id: 112,
    name: _TL_('Malaysia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.INDONESIAN]: [{
    id: 91,
    name: _TL_('Indonesia'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.VIETNAMESE]: [{
    id: 166,
    name: _TL_('Vietnam'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
  [LANGUAGE_TYPES.THAI]: [{
    id: 177,
    name: _TL_('Thailand'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
};

export const KRTLocationsCN = {
  [LANGUAGE_TYPES.SIMPLIFIED_CHINESE]: [{
    id: 39,
    name: _TL_('China'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  }],
};

export const KPLocations = [
  {
    id: 1,
    name: _TL_('Albania'),
  },
  {
    id: 3,
    name: _TL_('Algeria'),
  },
  {
    id: 4,
    name: _TL_('American Samoa'),
  },
  {
    id: 5,
    name: _TL_('Andorra'),
  },
  {
    id: 158,
    name: _TL_('Anguilla'),
  },
  {
    id: 7,
    name: _TL_('Antigua and Barbuda'),
  },
  {
    id: 8,
    name: _TL_('Argentina'),
  },
  {
    id: 205,
    name: _TL_('Armenia'),
  },
  {
    id: 131,
    name: _TL_('Aruba'),
  },
  {
    id: 9,
    name: _TL_('Australia'),
    landingPageAll: [LANGUAGE_TYPES.ENGLISH, LANGUAGE_TYPES.GERMAN, LANGUAGE_TYPES.FRENCH],
  },
  {
    id: 10,
    name: _TL_('Austria'),
    landingPageAll: [LANGUAGE_TYPES.GERMAN],
  },
  {
    id: 203,
    name: _TL_('Azerbaijan'),
  },
  {
    id: 11,
    name: _TL_('Bahamas'),
  },
  {
    id: 204,
    name: _TL_('Bahrain'),
  },
  {
    id: 12,
    name: _TL_('Bangladesh'),
  },
  {
    id: 13,
    name: _TL_('Barbados'),
  },
  {
    id: 14,
    name: _TL_('Belgium'),
  },
  {
    id: 21,
    name: _TL_('Belize'),
  },
  {
    id: 52,
    name: _TL_('Benin'),
  },
  {
    id: 15,
    name: _TL_('Bermuda'),
  },
  {
    id: 17,
    name: _TL_('Bolivia'),
  },
  {
    id: 198,
    name: _TL_('Bosnia and Herzegovina'),
  },
  {
    id: 18,
    name: _TL_('Botswana'),
  },
  {
    id: 20,
    name: _TL_('Brazil'),
  },
  {
    id: 24,
    name: _TL_('British Virgin Islands'),
  },
  {
    id: 25,
    name: _TL_('Brunei'),
  },
  {
    id: 26,
    name: _TL_('Bulgaria'),
  },
  {
    id: 191,
    name: _TL_('Burkina Faso'),
  },
  {
    id: 31,
    name: _TL_('Cameroon'),
  },
  {
    id: 32,
    name: _TL_('Canada'),
    landingPageAll: [LANGUAGE_TYPES.ENGLISH, LANGUAGE_TYPES.GERMAN, LANGUAGE_TYPES.FRENCH],
  },
  {
    id: 34,
    name: _TL_('Cayman Islands'),
  },
  {
    id: 35,
    name: _TL_('Central African Republic'),
  },
  {
    id: 38,
    name: _TL_('Chile'),
  },
  {
    id: 41,
    name: _TL_('Christmas Island'),
  },
  {
    id: 42,
    name: _TL_('Cocos (Keeling) Islands'),
  },
  {
    id: 43,
    name: _TL_('Colombia'),
  },
  {
    id: 226,
    name: _TL_('Comoros'),
  },
  {
    id: 47,
    name: _TL_('Cook Islands'),
  },
  {
    id: 48,
    name: _TL_('Costa Rica'),
  },
  {
    id: 94,
    name: _TL_('Cote d\'Ivoire'),
  },
  {
    id: 49,
    name: _TL_('Croatia'),
  },
  {
    id: 206,
    name: _TL_('Cyprus'),
  },
  {
    id: 51,
    name: _TL_('Czech Republic'),
    landingPageAll: [LANGUAGE_TYPES.CZECH],
  },
  {
    id: 46,
    name: _TL_('Democratic Republic of the Congo'),
  },
  {
    id: 53,
    name: _TL_('Denmark'),
    landingPageAll: [LANGUAGE_TYPES.DANISH],
  },
  {
    id: 69,
    name: _TL_('Djibouti'),
  },
  {
    id: 54,
    name: _TL_('Dominica'),
  },
  {
    id: 55,
    name: _TL_('Dominican Republic'),
  },
  {
    id: 56,
    name: _TL_('Ecuador'),
  },
  {
    id: 187,
    name: _TL_('Egypt'),
  },
  {
    id: 57,
    name: _TL_('El Salvador'),
  },
  {
    id: 61,
    name: _TL_('Estonia'),
  },
  {
    id: 59,
    name: _TL_('Ethiopia'),
  },
  {
    id: 60,
    name: _TL_('Eritrea'),
  },
  {
    id: 62,
    name: _TL_('Faroe Islands'),
  },
  {
    id: 199,
    name: _TL_('Fiji'),
  },
  {
    id: 65,
    name: _TL_('Finland'),
    landingPageAll: [LANGUAGE_TYPES.FINNISH],
  },
  {
    id: 66,
    name: _TL_('France'),
    landingPageAll: [LANGUAGE_TYPES.ENGLISH, LANGUAGE_TYPES.GERMAN, LANGUAGE_TYPES.FRENCH],
  },
  {
    id: 1279,
    name: _TL_('French Guiana'),
  },
  {
    id: 1292,
    name: _TL_('French Polynesia'),
  },
  {
    id: 70,
    name: _TL_('Gabon'),
  },
  {
    id: 72,
    name: _TL_('Germany'),
    landingPageAll: [LANGUAGE_TYPES.ENGLISH, LANGUAGE_TYPES.GERMAN, LANGUAGE_TYPES.FRENCH],
  },
  {
    id: 208,
    name: _TL_('Georgia'),
  },
  {
    id: 74,
    name: _TL_('Gibraltar'),
  },
  {
    id: 76,
    name: _TL_('Greece'),
  },
  {
    id: 77,
    name: _TL_('Greenland'),
  },
  {
    id: 78,
    name: _TL_('Grenada'),
  },
  {
    id: 79,
    name: _TL_('Guadeloupe'),
  },
  {
    id: 80,
    name: _TL_('Guam'),
  },
  {
    id: 81,
    name: _TL_('Guatemala'),
  },
  {
    id: 82,
    name: _TL_('Guinea'),
  },
  {
    id: 153,
    name: _TL_('Guinea-Bissau'),
  },
  {
    id: 83,
    name: _TL_('Guyana'),
  },
  {
    id: 84,
    name: _TL_('Haiti'),
  },
  {
    id: 87,
    name: _TL_('Honduras'),
  },
  {
    id: 200,
    name: _TL_('Hong Kong SAR'),
  },
  {
    id: 88,
    name: _TL_('Hungary'),
  },
  {
    id: 89,
    name: _TL_('Iceland'),
  },
  {
    id: 90,
    name: _TL_('India'),
    landingPageAll: [LANGUAGE_TYPES.ENGLISH],
  },
  {
    id: 91,
    name: _TL_('Indonesia'),
  },
  {
    id: 228,
    name: _TL_('Iraq'),
  },
  {
    id: 92,
    name: _TL_('Ireland'),
  },
  {
    id: 210,
    name: _TL_('Israel'),
  },
  {
    id: 93,
    name: _TL_('Italy'),
    landingPageAll: [LANGUAGE_TYPES.ITALIAN],
  },
  {
    id: 95,
    name: _TL_('Jamaica'),
  },
  {
    id: 96,
    name: _TL_('Japan'),
    landingPageAll: [LANGUAGE_TYPES.JAPANESE],
  },
  {
    id: 101,
    name: _TL_('Kyrgyzstan'),
  },
  {
    id: 104,
    name: _TL_('Latvia'),
  },
  {
    id: 103,
    name: _TL_('Lesotho'),
  },
  {
    id: 106,
    name: _TL_('Libya'),
  },
  {
    id: 107,
    name: _TL_('Liechtenstein'),
  },
  {
    id: 108,
    name: _TL_('Lithuania'),
  },
  {
    id: 109,
    name: _TL_('Luxembourg'),
  },
  {
    id: 201,
    name: _TL_('Macao SAR'),
  },
  {
    id: 110,
    name: _TL_('Madagascar'),
  },
  {
    id: 111,
    name: _TL_('Malawi'),
  },
  {
    id: 112,
    name: _TL_('Malaysia'),
  },
  {
    id: 113,
    name: _TL_('Maldives'),
  },
  {
    id: 115,
    name: _TL_('Malta'),
  },
  {
    id: 142,
    name: _TL_('Marshall Islands'),
  },
  {
    id: 116,
    name: _TL_('Martinique'),
  },
  {
    id: 117,
    name: _TL_('Mauritania'),
  },
  {
    id: 118,
    name: _TL_('Mauritius'),
  },
  {
    id: 1303,
    name: _TL_('Mayotte'),
  },
  {
    id: 119,
    name: _TL_('Mexico'),
  },
  {
    id: 120,
    name: _TL_('Monaco'),
  },
  {
    id: 121,
    name: _TL_('Mongolia'),
  },
  {
    id: 122,
    name: _TL_('Moldova'),
  },
  {
    id: 4994,
    name: _TL_('Montenegro'),
  },
  {
    id: 123,
    name: _TL_('Montserrat'),
  },
  {
    id: 126,
    name: _TL_('Namibia'),
  },
  {
    id: 127,
    name: _TL_('Nauru'),
  },
  {
    id: 128,
    name: _TL_('Nepal'),
  },
  {
    id: 129,
    name: _TL_('Netherlands'),
    landingPageAll: [LANGUAGE_TYPES.DUTCH],
  },
  {
    id: 1289,
    name: _TL_('New Caledonia'),
  },
  {
    id: 134,
    name: _TL_('New Zealand'),
  },
  {
    id: 136,
    name: _TL_('Niger'),
  },
  {
    id: 137,
    name: _TL_('Nigeria'),
  },
  {
    id: 223,
    name: _TL_('Niue'),
  },
  {
    id: 138,
    name: _TL_('Norfolk Island'),
  },
  {
    id: 140,
    name: _TL_('Northern Mariana Islands'),
  },
  {
    id: 139,
    name: _TL_('Norway'),
    landingPageAll: [LANGUAGE_TYPES.NORWEGIAN],
  },
  {
    id: 214,
    name: _TL_('Oman'),
  },
  {
    id: 144,
    name: _TL_('Pakistan'),
  },
  {
    id: 143,
    name: _TL_('Palau'),
  },
  {
    id: 145,
    name: _TL_('Panama'),
  },
  {
    id: 146,
    name: _TL_('Papua New Guinea'),
  },
  {
    id: 147,
    name: _TL_('Paraguay'),
  },
  {
    id: 148,
    name: _TL_('Peru'),
  },
  {
    id: 149,
    name: _TL_('Philippines'),
  },
  {
    id: 150,
    name: _TL_('Pitcairn Islands'),
  },
  {
    id: 151,
    name: _TL_('Poland'),
    landingPageAll: [LANGUAGE_TYPES.POLISH],
  },
  {
    id: 152,
    name: _TL_('Portugal'),
    landingPageAll: [LANGUAGE_TYPES.PORTUGUESE],
  },
  {
    id: 154,
    name: _TL_('Puerto Rico'),
  },
  {
    id: 215,
    name: _TL_('Qatar'),
  },
  {
    id: 157,
    name: _TL_('Rwanda'),
  },
  {
    id: 45,
    name: _TL_('Republic of Congo'),
  },
  {
    id: 186,
    name: _TL_('Republic of North Macedonia'),
  },
  {
    id: 155,
    name: _TL_('Reunion'),
  },
  {
    id: 224,
    name: _TL_('Romania'),
  },
  {
    id: 230,
    name: _TL_('Saint Kitts and Nevis'),
  },
  {
    id: 231,
    name: _TL_('Saint Lucia'),

  },
  {
    id: 1293,
    name: _TL_('Saint Pierre and Miquelon'),
  },
  {
    id: 233,
    name: _TL_('Saint Vincent and the Grenadines'),
  },
  {
    id: 195,
    name: _TL_('Samoa'),
  },
  {
    id: 159,
    name: _TL_('San Marino'),
  },
  {
    id: 216,
    name: _TL_('Saudi Arabia'),
  },
  {
    id: 161,
    name: _TL_('Senegal'),
  },
  {
    id: 4993,
    name: _TL_('Serbia'),
  },
  {
    id: 162,
    name: _TL_('Seychelles'),
  },
  {
    id: 163,
    name: _TL_('Sierra Leone'),
  },
  {
    id: 164,
    name: _TL_('Singapore'),
  },
  {
    id: 165,
    name: _TL_('Slovakia'),
  },
  {
    id: 167,
    name: _TL_('Slovenia'),
  },
  {
    id: 225,
    name: _TL_('Somalia'),
  },
  {
    id: 168,
    name: _TL_('South Africa'),
    landingPageAll: [LANGUAGE_TYPES.ENGLISH],
  },
  {
    id: 170,
    name: _TL_('Spain'),
    landingPageAll: [LANGUAGE_TYPES.SPANISH],
  },
  {
    id: 36,
    name: _TL_('Sri Lanka'),
  },
  {
    id: 172,
    name: _TL_('Suriname'),
  },
  {
    id: 174,
    name: _TL_('Sweden'),
    landingPageAll: [LANGUAGE_TYPES.SWEDISH],
  },
  {
    id: 175,
    name: _TL_('Switzerland'),
    landingPageAll: [LANGUAGE_TYPES.GERMAN],
  },
  {
    id: 40,
    name: _TL_('Taiwan'),
  },
  {
    id: 176,
    name: _TL_('Tajikistan'),
  },
  {
    id: 189,
    name: _TL_('Tanzania'),
  },
  {
    id: 177,
    name: _TL_('Thailand'),
  },
  {
    id: 178,
    name: _TL_('Togo'),
  },
  {
    id: 71,
    name: _TL_('The Gambia'),
  },
  {
    id: 179,
    name: _TL_('Tokelau'),
  },
  {
    id: 180,
    name: _TL_('Tonga'),
  },
  {
    id: 181,
    name: _TL_('Trinidad and Tobago'),
  },
  {
    id: 227,
    name: _TL_('Tunisia'),
  },
  {
    id: 182,
    name: _TL_('Turkey'),
  },
  {
    id: 184,
    name: _TL_('Turks and Caicos Islands'),
  },
  {
    id: 234,
    name: _TL_('Tuvalu'),
  },
  {
    id: 185,
    name: _TL_('Uganda'),
  },
  {
    id: 218,
    name: _TL_('United Arab Emirates'),
    landingPageAll: [LANGUAGE_TYPES.ENGLISH],
  },
  {
    id: 188,
    name: _TL_('United Kingdom'),
    landingPageAll: [LANGUAGE_TYPES.ENGLISH, LANGUAGE_TYPES.GERMAN, LANGUAGE_TYPES.FRENCH],
  },
  {
    id: 190,
    name: _TL_('United States'),
    landingPageAll: [LANGUAGE_TYPES.ENGLISH, LANGUAGE_TYPES.GERMAN, LANGUAGE_TYPES.FRENCH],
  },
  {
    id: 237,
    name: _TL_('United States Virgin Islands'),
  },
  {
    id: 192,
    name: _TL_('Uruguay'),
  },
  {
    id: 133,
    name: _TL_('Vanuatu'),
  },
  {
    id: 86,
    name: _TL_('Vatican City'),
  },
  {
    id: 202,
    name: _TL_('Venezuela'),
  },
  {
    id: 166,
    name: _TL_('Vietnam'),
  },
  {
    id: 1302,
    name: _TL_('Wallis and Futuna'),
  },
  {
    id: 219,
    name: _TL_('Yemen'),
  },
  {
    id: 196,
    name: _TL_('Zambia'),
  },
  {
    id: 169,
    name: _TL_('Zimbabwe'),
  },
];
